import React from "react";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import "./AirQualityCard.css";

const AirQualityCard = ({ param, value, unit, threshold }) => {
  const getColor = (val, thresh) => {
    if (val < thresh * 0.5) return "#8fce00";
    if (val < thresh * 0.75) return "#ffa500";
    if (val < thresh) return "#ff6b6b";
    return "#ff0000";
  };

  const Icon = param.icon;
  const percentage = Math.min((value / threshold) * 100, 100);
  const color = getColor(value, threshold);

  return (
    <div
      className="air-quality-card"
      style={{
        background: `linear-gradient(135deg, ${color}33 0%, ${color}66 100%)`,
        boxShadow: `0px 10px 20px 0px ${color}44`,
      }}
    >
      <div className="air-quality-card-header">
        <Icon size={24} color={color} />
        <div className="air-quality-progress">
          <CircularProgressbar
            value={percentage}
            text={`${Math.round(percentage)}%`}
            styles={buildStyles({
              pathColor: color,
              textColor: color,
              trailColor: "#ffffff33",
              textSize: "28px",
            })}
          />
        </div>
      </div>
      <div className="air-quality-card-content">
        <span className="air-quality-param-name">{param.name}</span>
        <span className="air-quality-value" style={{ color }}>
          {value}
        </span>
        <span className="air-quality-unit">{unit}</span>
      </div>
    </div>
  );
};

export default AirQualityCard;